import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Tag',
  alias: ['/sistema/crm/Tag/Index'],
  documento: 'crm',
  filas: ['166'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/TagController.cs',
} satisfies RutaProd;
